const DEFAULT_SYMBOLS_URL = 'https://libs.cartocdn.com/carto-vl/assets/symbols';

const bicycle = `${DEFAULT_SYMBOLS_URL}/bicycle.svg`;
const building = `${DEFAULT_SYMBOLS_URL}/building.svg`;
const bus = `${DEFAULT_SYMBOLS_URL}/bus.svg`;
const car = `${DEFAULT_SYMBOLS_URL}/car.svg`;
const circle = `${DEFAULT_SYMBOLS_URL}/circle.svg`;
const circleOutline = `${DEFAULT_SYMBOLS_URL}/circleOutline.svg`;
const cross = `${DEFAULT_SYMBOLS_URL}/cross.svg`;
const house = `${DEFAULT_SYMBOLS_URL}/house.svg`;
const flag = `${DEFAULT_SYMBOLS_URL}/flag.svg`;
const marker = `${DEFAULT_SYMBOLS_URL}/marker.svg`;
const markerOutline = `${DEFAULT_SYMBOLS_URL}/markerOutline.svg`;
const plus = `${DEFAULT_SYMBOLS_URL}/plus.svg`;
const square = `${DEFAULT_SYMBOLS_URL}/square.svg`;
const squareOutline = `${DEFAULT_SYMBOLS_URL}/squareOutline.svg`;
const star = `${DEFAULT_SYMBOLS_URL}/star.svg`;
const starOutline = `${DEFAULT_SYMBOLS_URL}/starOutline.svg`;
const triangle = `${DEFAULT_SYMBOLS_URL}/triangle.svg`;
const triangleOutline = `${DEFAULT_SYMBOLS_URL}/triangleOutline.svg`;

export default {
    bicycle,
    building,
    bus,
    car,
    circle,
    circleOutline,
    cross,
    house,
    flag,
    marker,
    markerOutline,
    plus,
    square,
    squareOutline,
    star,
    starOutline,
    triangle,
    triangleOutline
};
